import axios from 'axios';

export const chargeForEvent = (doctor_id, event_id, event_type, token) => {
  return axios.post('https://to125wqxtb.execute-api.us-east-1.amazonaws.com/dev/hkdu/eventCharge', {
    doctor_id,
    event_id,
    event_type,
    token,
  });
};
